<template><section>
<h2 id="radio-zu-jian"><a class="header-anchor" href="#radio-zu-jian" aria-hidden="true">¶</a> Radio组件</h2>
<h3 id="ji-chu-yong-fa"><a class="header-anchor" href="#ji-chu-yong-fa" aria-hidden="true">¶</a> 基础用法</h3>
<pre><code class="hljs language-html"><span class="hljs-tag">&lt;<span class="hljs-name">zan-radio</span> <span class="hljs-attr">name</span>=<span class="hljs-string">"1"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"radio1"</span>&gt;</span>单选框1<span class="hljs-tag">&lt;/<span class="hljs-name">zan-radio</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">zan-radio</span> <span class="hljs-attr">name</span>=<span class="hljs-string">"2"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"radio1"</span>&gt;</span>单选框2<span class="hljs-tag">&lt;/<span class="hljs-name">zan-radio</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data() {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">radio1</span>: <span class="hljs-string">'1'</span>
    }
  }
};
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
<h3 id="jin-yong-zhuang-tai"><a class="header-anchor" href="#jin-yong-zhuang-tai" aria-hidden="true">¶</a> 禁用状态</h3>
<pre><code class="hljs language-html"><span class="hljs-tag">&lt;<span class="hljs-name">zan-radio</span> <span class="hljs-attr">name</span>=<span class="hljs-string">"1"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"radio2"</span> <span class="hljs-attr">disabled</span>&gt;</span>未选中禁用<span class="hljs-tag">&lt;/<span class="hljs-name">zan-radio</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">zan-radio</span> <span class="hljs-attr">name</span>=<span class="hljs-string">"2"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"radio2"</span> <span class="hljs-attr">disabled</span>&gt;</span>选中且禁用<span class="hljs-tag">&lt;/<span class="hljs-name">zan-radio</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data() {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">radio2</span>: <span class="hljs-string">'2'</span>
    }
  }
};
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
<h3 id="radio-zu"><a class="header-anchor" href="#radio-zu" aria-hidden="true">¶</a> radio组</h3>
<pre><code class="hljs language-html"><span class="hljs-tag">&lt;<span class="hljs-name">zan-radio-group</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"radio3"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">zan-radio</span> <span class="hljs-attr">name</span>=<span class="hljs-string">"1"</span>&gt;</span>单选框1<span class="hljs-tag">&lt;/<span class="hljs-name">zan-radio</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">zan-radio</span> <span class="hljs-attr">name</span>=<span class="hljs-string">"2"</span>&gt;</span>单选框2<span class="hljs-tag">&lt;/<span class="hljs-name">zan-radio</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">zan-radio-group</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data() {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">radio3</span>: <span class="hljs-string">'1'</span>
    }
  }
};
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
<h3 id="yu-cell-zu-jian-yi-qi-shi-yong"><a class="header-anchor" href="#yu-cell-zu-jian-yi-qi-shi-yong" aria-hidden="true">¶</a> 与Cell组件一起使用</h3>
<pre><code class="hljs language-html"><span class="hljs-tag">&lt;<span class="hljs-name">zan-radio-group</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"radio4"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">zan-cell-group</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">zan-cell</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">zan-radio</span> <span class="hljs-attr">name</span>=<span class="hljs-string">"1"</span>&gt;</span>单选框1<span class="hljs-tag">&lt;/<span class="hljs-name">zan-radio</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">zan-cell</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">zan-cell</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">zan-radio</span> <span class="hljs-attr">name</span>=<span class="hljs-string">"2"</span>&gt;</span>单选框2<span class="hljs-tag">&lt;/<span class="hljs-name">zan-radio</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">zan-cell</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">zan-cell-group</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">zan-radio-group</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data() {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">radio4</span>: <span class="hljs-string">'1'</span>
    }
  }
};
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
<h3 id="radio-api"><a class="header-anchor" href="#radio-api" aria-hidden="true">¶</a> Radio API</h3>
<table class="table"><thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>默认值</th>
<th>可选值</th>
</tr>
</thead>
<tbody>
<tr>
<td>disabled</td>
<td>是否禁用单选框</td>
<td>Boolean</td>
<td>false</td>
<td></td>
</tr>
<tr>
<td>name</td>
<td>根据这个来判断radio是否选中</td>
<td>Boolean</td>
<td>false</td>
<td></td>
</tr>
</tbody>
</table>
<h3 id="radiogroup-api"><a class="header-anchor" href="#radiogroup-api" aria-hidden="true">¶</a> RadioGroup API</h3>
<table class="table"><thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>默认值</th>
<th>可选值</th>
</tr>
</thead>
<tbody>
<tr>
<td>disabled</td>
<td>是否禁用单选框</td>
<td>Boolean</td>
<td>false</td>
<td></td>
</tr>
</tbody>
</table>
</section></template>

<script>
export default {
  data() {
    return {
      radio: '1'
    };
  }
};
</script>


// WEBPACK FOOTER //
// radio-11.vue?5049477b